export default __webpack_public_path__ + "static/media/70px-Headshot.dc746f5f.webp";